import { z } from 'zod';

/**
 * Stripe subscription mirror (decisions-log R5: DDB-only). Stripe remains the
 * source of truth; this denormalized item per customer lives in
 * `dgm-{env}-subscriptions` for fast in-app reads. Scaffold-only this session
 * (D: Stripe stub) — no live Stripe account yet.
 */

export const SubscriptionTier = z.enum(['free', 'pro', 'team']);
export type SubscriptionTier = z.infer<typeof SubscriptionTier>;

export const SubscriptionStatus = z.enum([
  'active',
  'trialing',
  'past_due',
  'canceled',
  'incomplete',
  'unpaid',
]);
export type SubscriptionStatus = z.infer<typeof SubscriptionStatus>;

export const SubscriptionMirror = z.object({
  /** Cognito sub of the owning user. PK. */
  userSub: z.string(),
  stripeCustomerId: z.string().optional(),
  stripeSubscriptionId: z.string().optional(),
  tier: SubscriptionTier.default('free'),
  status: SubscriptionStatus.default('active'),
  /** Epoch seconds; when the current period ends (for cancel-at-period-end UX). */
  currentPeriodEnd: z.number().int().optional(),
  cancelAtPeriodEnd: z.boolean().default(false),
  updatedAt: z.string().datetime(),
});
export type SubscriptionMirror = z.infer<typeof SubscriptionMirror>;

/** A DSAR ticket (privacy request from a non-account-holder). DDB `dgm-{env}-dsar`. */
export const DsarTicket = z.object({
  ticketId: z.string(),
  email: z.string().email(),
  requestType: z.enum(['access', 'delete', 'opt_out', 'correction']),
  details: z.string().max(2000).optional(),
  status: z.enum(['open', 'in_progress', 'resolved']).default('open'),
  createdAt: z.string().datetime(),
  resolvedAt: z.string().datetime().optional(),
});
export type DsarTicket = z.infer<typeof DsarTicket>;
